import React from 'react';

import Head from 'next/head';

const OpenGraphCard = ({ slice }) => {
  const data = slice.primary;
  const image = data?.image;

  return (
    <Head>
      {data['title'] && (
        <meta key="og:title" content={data['title']} property="og:title" />
      )}
      {data['description'] && (
        <meta
          key="og:description"
          content={data['description']}
          property="og:description"
        />
      )}
      {data['type'] && (
        <meta key="og:type" content={data['type']} property="og:type" />
      )}
      {image?.url && (
        <>
          <meta key="og:image" content={image.url} property="og:image" />
          <meta
            key="og:image:secure_url"
            content={image.url}
            property="og:image:secure_url"
          />
          {image.alt && (
            <meta
              key="og:image:alt"
              content={image.alt}
              property="og:image:alt"
            />
          )}
        </>
      )}
    </Head>
  );
};

export default OpenGraphCard;
